import { client } from '@platform/http/api-client';

const projectKickoffApi = {
  // Project Creators
  async getProjectCreators() {
    const response = await client.get('/api/project-creators');
    return response.data;
  },
  async getProjectCreator(id) {
    const response = await client.get(`/api/project-creators/${id}`);
    return response.data;
  },
  async createProjectCreator(data) {
    const response = await client.post('/api/project-creators', data);
    return response.data;
  },
  async updateProjectCreator(id, data) {
    const response = await client.put(`/api/project-creators/${id}`, data);
    return response.data;
  },
  async deleteProjectCreator(id) {
    const response = await client.delete(`/api/project-creators/${id}`);
    return response.data;
  },

  // Work Item Creators
  async getWorkItemCreators() {
    const response = await client.get('/api/work-item-creators');
    return response.data;
  },
  async getWorkItemCreator(id) {
    const response = await client.get(`/api/work-item-creators/${id}`);
    return response.data;
  },
  async createWorkItemCreator(name, projectKey, issueTypeId, issueTypeName, dataSourceId = 'jira-default', config = {}) {
    const response = await client.post('/api/work-item-creators', { name, projectKey, issueTypeId, issueTypeName, dataSourceId, config });
    return response.data;
  },
  async updateWorkItemCreator(id, name, projectKey, issueTypeId, issueTypeName, dataSourceId = 'jira-default', config = {}) {
    const response = await client.put(`/api/work-item-creators/${id}`, { name, projectKey, issueTypeId, issueTypeName, dataSourceId, config });
    return response.data;
  },
  async deleteWorkItemCreator(id) {
    const response = await client.delete(`/api/work-item-creators/${id}`);
    return response.data;
  },

  // Creation Trees
  async getCreationTrees() {
    const response = await client.get('/api/creation-trees');
    return response.data;
  },
  async getCreationTree(id) {
    const response = await client.get(`/api/creation-trees/${id}`);
    return response.data;
  },
  async getCreationTreeByScheme(schemeId) {
    const response = await client.get(`/api/creation-trees/by-scheme/${schemeId}`);
    return response.data;
  },
  async createCreationTree(name, issueTypeSchemeId, issueTypeSchemeName, treeData) {
    const response = await client.post('/api/creation-trees', { name, issueTypeSchemeId, issueTypeSchemeName, treeData });
    return response.data;
  },
  async updateCreationTree(id, name, issueTypeSchemeId, issueTypeSchemeName, treeData) {
    const response = await client.put(`/api/creation-trees/${id}`, { name, issueTypeSchemeId, issueTypeSchemeName, treeData });
    return response.data;
  },
  async deleteCreationTree(id) {
    const response = await client.delete(`/api/creation-trees/${id}`);
    return response.data;
  },

  // Batch create preflight — validate every work item against its project's
  // schemes/workflows before anything is created. Returns { ok, blockers }.
  async createPreflight(items) {
    const response = await client.post('/api/issue/create-preflight', { items });
    return response.data;
  },
};

export default projectKickoffApi;
